import { Color } from '@lib/color';
import {DateTime} from '../lib/date-time';
import { geojson } from '@lib/geojson';

export class VehicleQueryLocationByIntervalBody{
	public email:string;
	public authToken:string;
    public vehicleIds:string;
	public begin:DateTime;
	public end:DateTime;
}

export namespace VehicleLocationQuery{
	export namespace Interval{
		export type Body=VehicleQueryLocationByIntervalBody;
		export const Body=VehicleQueryLocationByIntervalBody;
		export interface IdleIntervalHistory{
			startTime:number,
			endTime:number|null,
			durationSeconds:number,
			status:string
		}
		
		export interface VehicleLocations{
			vehicleName:string
			vehicleId:number,
			vehicleLocations: geojson.Coord[],
			locationTimes: number[],
			locationSpeeds: (number|null)[],
			locationOdometers: (number|null)[],
			averageSpeedMph:number,
			latestOdometer:number|null,
			idleTimeSeconds:number,
			idleIntervals:IdleIntervalHistory[]
		}
		export interface VehicleLocationsWithPathColor{
			vehicleName:string
			vehicleId:number,
			color:Color,
			vehicleLocations:geojson.Coord[],
			locationTimes: number[],
			locationSpeeds: (number|null)[],
			locationOdometers: (number|null)[],
			averageSpeedMph:number,
			latestOdometer:number|null,
			idleTimeSeconds:number,
			idleIntervals:IdleIntervalHistory[]
		}
		export interface Response{
			begin:DateTime;
			end:DateTime;
			tracePaths:VehicleLocations[];
		}
		export interface error{
			type:string,
			message:string
		}
	}
}
